let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5SiDe"), load("hF4Kk"), load("ePj2T"), load("i2Wqw"), load("fId8x"), load("aZinD"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));